import React from 'react';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ValidationText from '../atoms/ValidationText';
import { getShopDetail } from '../../actions/Shop';
import RequiredButton from '../atoms/RequiredButton';
import ToggleLalapayEnableDialogConfirm from './ToggleLalapayEnableDialogConfirm';

const styles = theme => ({
  radioRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    padding: theme.spacing(2)
  },
  dialogReceipt: {
    width: 600
  },
  description: {
    display: 'block',
    fontSize: 24,
    marginBottom: 20,
    fontWeight: 400
  },
  titleShop: {
    fontSize: 18
  },
  textTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#000000',
    marginTop: 30,
    marginBottom: 20
  },
  mb10: {
    marginBottom: 10
  },
  mt10: {
    marginTop: 10
  },
  flexStart: {
    justifyContent: 'flex-start',
    padding: '10px 16px'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset,
      accessibleShops: state.shops.accessibleShops,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators({ getShopDetail }, dispatch)
    })
  ),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    lalapayEnable,
    setLalapayEnable,
    params,
    shopName,
    setShopName,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    shopNameError,
    setShopNameError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    detailOpenAction,
    hasDetail,
    setHasDetail,
    onCloseDialog
  }) => {
    const errors = {
      shopNameError,
      bankNameError,
      bankBranchNameError,
      bankAccountNumberError,
      bankAccountHolderError
    };

    const editInput = {
      shopName,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder
    };
    const cancelActionConfirm = () => {
      updateOpenChangeConfirm(false);
    };

    const updateLalapayEnable = value => {
      setLalapayEnable(value);

      if (parseInt(value, 10) === 1 && params.lalapayShopId) {
        setHasDetail(true);
        if (!hasDetail) {
          detailOpenAction(params.lalapayShopId);
        }
      }
    };

    const validShopName = () => {
      const value = shopName ? shopName.trim() : '';
      // const value = shopName;
      if (!value) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopName(value);
      return 0;
    };

    const validBankName = () => {
      const value = bankName ? bankName.trim() : '';
      if (!value) {
        setBankNameError('必須項目です。');
        return 1;
      }
      setBankNameError('');
      setBankName(value);
      return 0;
    };

    const validBankBranchName = () => {
      const value = bankBranchName ? bankBranchName.trim() : '';
      if (!value) {
        setBankBranchNameError('必須項目です。');
        return 1;
      }
      setBankBranchNameError('');
      setBankBranchName(value);
      return 0;
    };

    const validBankAccountNumber = () => {
      const value = bankAccountNumber ? bankAccountNumber.trim() : '';
      if (!value) {
        setBankAccountNumberError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setBankAccountNumberError('半角数字のみで7桁で入力してください。');
        return 1;
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };

    const validBankAccountHolder = () => {
      const value = bankAccountHolder ? bankAccountHolder.trim() : '';
      if (!value) {
        setBankAccountHolderError('必須項目です。');
        return 1;
      }
      if (
        !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
          value
        )
      ) {
        setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
        return 1;
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };

    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };

    const valid = () => {
      const errorCount =
        validShopName() +
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder();

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const changeActionConfirm = () => {
      if (parseInt(lalapayEnable, 10) === 1 && !valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenChangeConfirm(true);
      }
    };

    return (
      <Dialog
        open={openChange}
        onClose={() => {
          updateOpenChange(false);
          updateLalapayEnable(params.lalapayEnable);
          onCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.dialogReceipt}>
          <Typography component="h3" className={classes.description}>
            ララペイ利用機能
          </Typography>
          <Paper className={classes.paper} elevation={1}>
            <RadioGroup
              value={String(lalapayEnable || params.lalapayEnable || 0)}
              onChange={e => {
                updateLalapayEnable(e.target.value);
              }}
              className={classes.radioRow}
            >
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label="利用する"
              />
              <FormControlLabel
                value="0"
                control={<Radio color="primary" />}
                label="利用しない"
              />
            </RadioGroup>

            {parseInt(lalapayEnable, 10) === 1 && (
              <>
                {/* Shop name */}
                <div className={classes.mt10}>
                  <RequiredButton />
                  <TextField
                    required
                    label="店舗名"
                    defaultValue={editInput.shopName}
                    value={shopName}
                    placeholder="ごち屋　天神店"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    inputProps={{
                      maxLength: 1000
                    }}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                    onBlur={validShopName}
                  />
                  <ValidationText message={errors.shopNameError} />
                </div>

                {/* Bank info */}
                <div className={classes.textTitle}>銀行口座情報</div>
                {/* Bank name */}
                <div className={classes.mb10}>
                  <RequiredButton />
                  <TextField
                    required
                    label="銀行名"
                    defaultValue={editInput.bankName}
                    value={bankName}
                    placeholder="○○銀行"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankName(e.target.value);
                    }}
                    onBlur={validBankName}
                  />
                  <ValidationText message={errors.bankNameError} />
                </div>

                {/* branch name */}
                <div className={classes.mb10}>
                  <RequiredButton />
                  <TextField
                    required
                    label="支店名"
                    defaultValue={editInput.bankBranchName}
                    value={bankBranchName}
                    placeholder="○○支店"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankBranchName(e.target.value);
                    }}
                    onBlur={validBankBranchName}
                  />
                  <ValidationText message={errors.bankBranchNameError} />
                </div>

                {/* Account number  */}
                <div className={classes.mb10}>
                  <RequiredButton />
                  <TextField
                    required
                    label="口座番号"
                    defaultValue={editInput.bankAccountNumber}
                    value={bankAccountNumber}
                    placeholder="1234567"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountNumber(e.target.value);
                    }}
                    onBlur={validBankAccountNumber}
                  />
                  <ValidationText message={errors.bankAccountNumberError} />
                </div>

                {/* Account holder name */}
                <div className={classes.mb10}>
                  <RequiredButton />
                  <TextField
                    required
                    label="口座名義"
                    defaultValue={editInput.bankAccountHolder}
                    value={bankAccountHolder}
                    placeholder="ヤマダ　タロウ"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountHolder(e.target.value);
                    }}
                    onBlur={validBankAccountHolder}
                  />
                  <ValidationText message={errors.bankAccountHolderError} />
                </div>

                {/* Account type */}
                <div className={classes.mb10}>
                  <RequiredButton />
                  <Typography component="p" className={classes.mt10}>
                    口座種別
                  </Typography>
                  <RadioGroup
                    row
                    value={bankAccountType}
                    onChange={e => {
                      setBankAccountType(e.target.value);
                      convertBankAccountTypeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="SAVINGS"
                      control={<Radio color="primary" />}
                      label="普通預金"
                    />
                    <FormControlLabel
                      value="CHECKING"
                      control={<Radio color="primary" />}
                      label="当座預金"
                    />
                  </RadioGroup>
                </div>
              </>
            )}
          </Paper>
        </DialogContent>
        <DialogActions className={classes.flexStart}>
          <CancelButton
            onClickAction={() => {
              cancelAction();
              updateLalapayEnable(params.lalapayEnable);
              onCloseDialog();
            }}
            color="default"
          />
          <ChangeButton onClickAction={changeActionConfirm} btnText="確認" />
        </DialogActions>
        <ToggleLalapayEnableDialogConfirm
          message="レシート利用機能 確認"
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          cancelAction={cancelActionConfirm}
          changeAction={changeAction}
          lalapayEnable={lalapayEnable || 0}
          editInput={editInput}
          lalapayShopId={params.lalapayShopId}
        />
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
